export enum MembershipPlanPeriodsTermType {
  Annual = '0',
  Days_14 = '1',
  Days_30 = '2',
}
